'use client'

import { ReactNode, useState } from 'react'

import { Modal } from '@/shared/ui'

import cl from './ConfirmModal.module.scss'

interface ConfirmModalProps {
	children: ReactNode
	title: string
	description?: string
	okText?: string
	cancelText?: string
	onConfirm?: () => void
	onCancel?: () => void
	className?: string
}

export const ConfirmModal = (props: ConfirmModalProps) => {
	const { children, title, description, okText = 'Да', cancelText = 'Отмена', onConfirm, onCancel, className } = props

	const [isOpen, setIsOpen] = useState(false)

	const handleOpen = () => {
		setIsOpen(true)
	}

	const handleClose = () => {
		setIsOpen(false)
		onCancel?.()
	}

	const handleConfirm = () => {
		onConfirm?.()
		setIsOpen(false)
	}

	return (
		<>
			<span onClick={handleOpen} className={cl.trigger}>
				{children}
			</span>

			<Modal
				isOpen={isOpen}
				onClose={handleClose}
				onOk={handleConfirm}
				onCancel={handleClose}
				okText={okText}
				cancelText={cancelText}
				className={className}
				contentClassName={cl.content}>
				<div className={cl.body}>
					<h4 className={cl.title}>{title}</h4>
					{description && <p className={cl.description}>{description}</p>}
				</div>
			</Modal>
		</>
	)
}
